import { Link } from 'react-router';

import SearchResultsTable from 'components/SearchResultsTable/SearchResultsTable';

const columns = [
  {
    title: 'Primary Applicant',
    dataIndex: 'primaryApplicantName',
    key: 'primaryApplicantName',
  },
  {
    title: 'Application ID',
    dataIndex: 'applicationId',
    key: 'applicationId',
    render: (applicationId) => {
      return <Link to={`/applications/${applicationId}`}>{applicationId}</Link>;
    },
  },
  {
    title: 'Type',
    dataIndex: 'type',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: 'Status Reason',
    dataIndex: 'statusReason',
    key: 'statusReason',
  },
];

const ApplicationSearchResults = ({
  loading,
  onPageChange,
  page,
  searchResults,
  emptyText,
}) => {
  return (
    <SearchResultsTable
      columns={columns}
      data={searchResults}
      loading={loading}
      emptyText={emptyText || 'No applications found'}
      pagination={{
        current: page || undefined,
        onChange: onPageChange,
      }}
    />
  );
};

export default ApplicationSearchResults;
